// extracted by mini-css-extract-plugin
module.exports = {"message":"WarningInputMessage_message_3ICtY"};